<script>
import { Radar } from 'vue-chartjs';

export default {
  extends: Radar,
  props: ['data'],
  data() {
    return {
      chartOptions: {
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
        scale: {
          ticks: {
            beginAtZero: true,
            min: 0,
            max: 100,
            stepSize: 20,
            fontColor: 'rgba(255,255,255,0)',
            showLabelBackdrop: false,
          },
          pointLabels: {
            fontSize: 12,
            fontColor: '#fff',
          },
          gridLines: {
            color: 'rgba(255, 255, 255, 0.2)',
          },
          angleLines: {
            color: 'rgba(255, 255, 255, 0.2)',
          },
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.data, this.chartOptions);
  },
};
</script>




// WEBPACK FOOTER //
// src/components/CompChartRadar.vue